export default "__VITE_ASSET__BXpp5Z_z__"